export default [
  {
    type: "epc",
    name: "Sparkasse Rheinfelden",
    bic: "SKLODE66XXX",
    empfaenger: "CLINIUS GmbH",
    iban: "DE22683500480001099472",
    waehrung: "EUR"
  },
  {
    type: "swiss",
    name: "Postfinance Schweiz",
    bic: "POFICHBEXXX",
    empfaenger: "CLINIUS GmbH",
    iban: "CH5509000000914066628",
    waehrung: "EUR",
    adresse: "Hebelstraße",
    hausnr: "19a",
    plz: "79618",
    ort: "Rheinfelden",
    land: "DE"
  }
]
